<template>
    <div
        class="incidents-calendar card mt-3"
        v-if="!loading"
    >
        <div class="card-body">
            <calendar-heatmap
                :end-date="new Date()"
                :range-color="['#fcf3ec', '#fad6bb', '#f5b98d', '#ef9b61', '#e67c37']"
                :tooltip-unit="$t('incidents')"
                :values="incidents"
            />
        </div>
    </div>
</template>

<script>
    import {CalendarHeatmap} from 'vue-calendar-heatmap'

    export default {
        name: "IncidentsCalendar",
        components: {
            CalendarHeatmap
        },
        data() {
            return {
                loading: true,
                incidents: []
            }
        },
        mounted() {
            this.getIncidents();
        },
        methods: {
            getIncidents() {
                let self = this;
                self.loading = true;
                // Get all settings values
                axios.get('api/widget/incidents/calendar').then(function (response) {
                    self.incidents = response.data.data;
                    self.loading = false;
                });
            }
        }
    }
</script>
